<template>
  <div class="fullpage-box">
   
        <Page1 />
     <!-- </div>
      <div class="section"> -->
      <keep-alive>
        <component :is="'Page2'"></component>
      </keep-alive>


    <!--手机端新加 start-->
    <div v-if="$flag" class="hbg">

      <div v-for="(list,index) in bdata" class="span4 col-md-6 col-xs-12 wow " :key="index" :class="(index%2==0?'fadeInLeft':'fadeInRight')+(index>0?' mt-20':'')"  >
        <div class="list_backimg list_backimg3 mlist">

          <div class="list_img list-img fleft" :class="index%2==0?'fleft':'fright'">
            <div style="transform: skewX(15deg);">
              <div class="left-o-text" :class="'num-'+index">{{list.num}}</div>
              <div class="left-t-text" :class="'unit-'+index">{{list.unit}}</div>
            </div>
          </div>
          <div class="list_txt list-txt fleft">
            <div style="transform: skewX(15deg);">
              <div class="list_title ">{{list.otitle}}</div>
              <div class="list_text">{{list.tip}}</div>
            </div>
          </div>

        </div>

      </div>






    </div>
    <!--手机端新加 end-->

        <Page3 />
      <!-- </div>
      <div class="section"> -->
        <Page4 />
      <!-- </div>
      <div class="section"> -->
        <Page5 />
      <!-- </div>
      <div class="section"> -->
        <Page6/>

         <b-menu :tnum="1"></b-menu>
      <!-- </div>
    </full-page> -->
    <!--<div class="chat-box-v" @click="openChat()">
		<div class="new-msg-box" :style="'display:'+(countMessage>0?'block':'none')" id="new_msg_count">{{countMessage}}</div>
      <el-badge :value="countMessage" class="item" v-if="countMessage">
        <img src="../assets/images/chat-v.png" alt />
       
      </el-badge>
      <template v-else>
        <img src="../assets/images/chat-v.png" alt />
         
      </template>
    </div>-->
	<div class="chat-box-v" @click="openChat()">
		<div class="new-msg-box" :style="'display:'+(countMessage>0?'block':'none')" id="new_msg_count">{{countMessage}}</div>
	    <img src="../assets/images/chat-v.png" alt />
	     
	   
	</div>

  </div>
</template>

<script>
 import BMenu from "../components/bMenu";
 const Page2 = () => import('./fullpage/page2')
import Page1 from "./fullpage/page1.vue";
//import Page2 from "./fullpage/page2.vue";
import Page3 from "./fullpage/page3.vue";
import Page4 from "./fullpage/page4.vue";
import Page5 from "./fullpage/page5.vue";
import { unreadMessage, messageCount } from "@/api/chat";
import Page6 from "./fullpage/page6.vue";
import { WOW } from "wowjs";
import $ from "jquery";
export default {
  name: "fullpage",
  components: {
    BMenu,
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
  },
  data() {
    return {
      options: {
        domnload_page2:false,
        licenseKey: "YOUR_KEY_HEERE",
        resize: true,
        loopBottom: true,
        css3: true,
        navigation: true,
        anchors: ["page1", "page2", "page3", "page4", "page5", "page6"],
        menu: "#menu",
        scrollBar: false,
      },
      countMessage: 0,
      handlelog: true,
      bdata:[]
    };
  },

  watch: {
    "$route.hash"() {
      try {
        if (this.$route.hash !== "#page2") {
          if (this.$route.hash === "#page1" || this.$route.hash === "") {
            $("#init-header").css("display", "block");
          }

          $(".chat-box-v").css({
            right: "-206px",
          });
          setTimeout(() => {
            $(".chat-box-v").animate({
              right: "0px",
            });
          }, 1000);
        }
        // $("#init-header").css("display",'none');
        else {
          $(".chat-box-v").css({
            right: "-206px",
          });
        }
        // $("#init-header").css("display",'block');
      } catch (e) {
        // $('.chat-box-v').css({
        //     'right':'-86px'
        //   })
      }
    },
  },
  methods: {
    async unreadMessage() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let res = {};
      if (userInfo) {
        res = await unreadMessage();
      } else {
        res = await messageCount();
      }
      const { code, data, msg } = res.data;
      this.handlelog = true;
      if (code == 200) {
        localStorage.setItem("admin_ids", data.admin_id); //该客户是否分配了跟单员  0 - 未分配
        if (data.count && this.countMessage != data.count) {
          this.countMessage = data.count ? data.count : "";
        }
      }
    },
    openChat() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : "";
      let newObj = {};
      if (userInfo) {
        newObj = this.$router.resolve({ path: "/groupchat" });
      } else {
        newObj = this.$router.resolve({ path: "/visitorchat" });
      }
      window.open(newObj.href, "_blank");
    },
  },
   
  mounted() {
    if(this.$flag){
      this.$api["get"]("u_h/tdata").then(res=>{
          this.bdata=res.data.data;
      });
    }
   // console.log(this.$flag,"==flag===flag===flag===")
    let that = this;
    $("#init-header").css("display", "block");
    // $(window).mousemove(function (e) {
    //   if (that.$route.hash === "#page1" || that.$route.hash === "") {
    //     $("#init-header").css("display", "block");
    //     return;
    //   }
    //   if (
    //     e.pageY < 80 &&
    //     $("#init-header").css("display") === "none" &&
    //     that.$route.hash != "#page2"
    //   ) {
    //     $("#init-header").css("display", "block");
    //     return;
    //   } else if (e.pageY > 79 && $("#init-header").css("display") === "block") {
    //     $("#init-header").css("display", "none"); 
    //   }
    // });
    let wow = new WOW({
      live: false,
    }).init();
    // 判断是否是分享链接
    if (this.$route.query.code) {
      localStorage.setItem("shareCode", this.$route.query.code);
    }
    // 判断是是否在第二页刷新
    // if (this.$route.hash == "#page2") {
    //   $(".chat-box-v").css({
    //     right: "-206px",
    //   });
    // }
    // 定时请求消息未读
	this.unreadMessage();
	return;
    this.timer = setInterval(() => {
      if (that.handlelog) {
        //判断是否已经完成
        that.handlelog = false;
        that.unreadMessage();
      }
    }, 10000);
  },
  destroyed() {
    // 清空定时器
	return;
    clearInterval(this.timer);
    this.timer = null;
    $(".chat-box-v").css({
      right: "0px",
    });
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/animate.min.css";
@import "../assets/css/own.css";
ul,
li,
ol {
  list-style-type: none;
}
.fullpage-box {
  background-color: #fff;
  min-width: 1200px;
}

#menu {
  margin: 0;
  padding: 0;
  position: fixed;
  right: 10px;
  top: 50%;
  list-style-type: none;
  z-index: 70;
  height: 180px;
  margin-top: -90px;
}
#menu li:not(:last-child) {
  margin-bottom: 1.041vw;
}
#menu a {
  width: 1.041vw;
  height: 1.041vw;
  border-radius: 50%;
  background-color: #fff;
  display: inline-block;
  border: 2px solid rgba(70, 148, 214, 0.71);
}
#menu .active a {
  background-color: #333;
  border-color: #333333;
}
.section {
  text-align: center;
  color: #fff;
}
@media screen and (max-width: 720px) {
  .fullpage-box {
    width: 100%;
    min-width: auto;
  }
}
.new-msg-box{
	position:absolute;
	background:#f00;
	color:#fff;
	width:20px;
	height:20px;
	line-height:18px;
	border-radius:10px;
	text-align:center;
	font-size:10px;
	left:10px;
	top:-15px;
	display:none;
	border:2px solid #fff;
}
</style> 